<template>
  <v-app>
    <v-container fluid>
      <!-- Banner Carousel at the Top -->
      <v-carousel height="400" width="400" v-if="this.$vuetify.display.smAndUp" hide-delimiters :show-arrows="false"
        hide-delimiter-background>
        <v-carousel-item v-for="(banner, index) in banners" :key="index" :src="banner" :cover="false"></v-carousel-item>
      </v-carousel>
      <v-carousel height="200" width="200" v-if="!this.$vuetify.display.smAndUp" hide-delimiters :show-arrows="false" hide-delimiter-background>
        <v-carousel-item v-for="(banner, index) in mobileBanners" :key="index" :src="banner"
          :cover="false"></v-carousel-item>
      </v-carousel>

      <v-row>
        <v-col>
          <v-card class="mx-auto card-margin">
            <template v-slot:title>
              <span class="font-weight-black">Stree Bal, Desh Ka Bal</span>
            </template>

            <v-card-text class="bg-surface-light pt-4">
              Stree bal is an initiative by Dr Seema Rao, India's first woman commando trainer, to highlight the
              endeavors, struggles & extraordinary challenges in the life of the common woman. India's wonder woman
              along with Dr. Komal Rao brings to you stories of these unsung sheroes who form the backbone of our
              society.<br>
              This podcast was born out of a passion for empowering the ordinary everyday woman and sharing their
              stories. Each episode is
              designed
              to inspire and connect listeners with a variety of guests who share their journeys, insights, and
              knowledge.
              <p>The vision of the producer is to create a platform that showcases women's voices and stories from
                various
                backgrounds.</p>
              <p>They aim to foster community engagement and raise awareness about women's issues through insightful
                discussions.</p>
              <p>
                To contact us, please visit the
                <router-link :to="{ name: 'ContactUs' }">Contact Us</router-link> page.
              </p>
            </v-card-text>
          </v-card>

          <v-carousel height="576" width="576" v-if="!this.$vuetify.display.smAndDown" hide-delimiters
            :show-arrows="false" hide-delimiter-background>
            <v-carousel-item v-for="(banner, index) in midImages" :key="index" :src="banner"
              :cover="true"></v-carousel-item>
          </v-carousel>
          <v-carousel v-if="this.$vuetify.display.smAndDown" hide-delimiters :show-arrows="false"
            hide-delimiter-background>
            <v-carousel-item v-for="(banner, index) in mobileMidImages" :key="index" :src="banner"
              :cover="true"></v-carousel-item>
          </v-carousel>

          <v-card class="mx-auto card-margin">
            <template v-slot:title>
              <span class="font-weight-black">Topics We Explore</span>
            </template>

            <v-card-text class="bg-surface-light pt-4">
              <p>Stories of Resilience, Homemaker, Leadership & Success, Health & Wellness, Entrepreneurship &
                Innovation,
                Personal Growth</p>
            </v-card-text>
          </v-card>

          <v-card class="mx-auto card-margin">
            <template v-slot:title>
              <span class="font-weight-black">Podcasts</span>
            </template>

            <v-card-text class="bg-surface-light pt-4">
              <v-container class="bg-surface-variant">
                <v-row no-gutters>
                  <!-- Assuming you have a list of podcast videos -->
                  <v-col
                    v-for="video in youtubeVideos"
                    :key="video.id"
                    cols="12"
                  >
                    <v-sheet class="ma-2 pa-2" outlined @click="playVideo(video)">
                      <!-- Show thumbnail if not playing -->
                      <!-- Show thumbnail if not playing -->
                      <div
                        v-if="activeVideo?.id !== video.id"
                        class="video-thumbnail-wrapper"
                      >
                        <img :src="video.thumbnail" class="video-thumbnail" />
                        <div class="play-button-overlay">
                          <div class="play-button"></div>
                        </div>
                      </div>


                      <!-- Title above video -->
                      <div class="video-title font-weight-medium mb-2">
                        {{ video.title }}
                      </div>

                      <!-- Show YouTube video -->
                      <iframe
                        v-if="activeVideo?.id === video.id && video.type === 'youtube'"
                        :src="`https://www.youtube-nocookie.com/embed/${video.videoId}?autoplay=1`"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        class="responsive-iframe"
                      ></iframe>

                      <!-- Show self-hosted video -->
                      <video
                        v-if="activeVideo?.id === video.id && video.type === 'local'"
                        :src="video.videoUrl"
                        controls
                        autoplay
                        class="responsive-video"
                      >
                        Your browser does not support the video tag.
                      </video>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

  </v-app>
</template>

<script>
export default {
  data() {
    return {
      activeVideo: null,
      banners: [
        require('@/assets/banner-3.png'),
        // require('@/assets/banner-1.jpg'),
        // require('@/assets/banner-2.jpg'),
      ],
      mobileBanners: [
        require('@/assets/banner-mobile-3.png'),
        // require('@/assets/banner-mobile-1.jpg'),
        // require('@/assets/banner-mobile-2.jpg'),
      ],
      midImages: [
        // require('@/assets/banner-3.png'),
        // require('@/assets/banner-1.jpg'),
        require('@/assets/banner-2.jpg'),
      ],
      mobileMidImages: [
        // require('@/assets/banner-mobile-3.png'),
        // require('@/assets/banner-mobile-1.jpg'),
        require('@/assets/banner-mobile-2.jpg'),
      ],
      youtubeVideos: [
        { id: 1, type: 'local', videoUrl: 'https://streebal.com/videos/commando-stories-podcast-1.mp4', title: "Dr. Deepak Rao & Dr. Komal Rao on Commando Training", thumbnail: require('@/assets/thumbnail-podcast-1.png'), thumbnailNum: "0", descriptionBefore: "Dr. Deepak Rao & Dr. Komal Rao on Commando Training", descriptionAfter: "Dr. Deepak Rao & Dr. Komal Rao on Commando Training" },
        { id: 2, type: 'local', videoUrl: 'https://streebal.com/videos/commando-stories-podcast-2.mp4', title: "Dr. Deepak Rao & Dr. Komal Rao on Indian Special Forces", thumbnail: require('@/assets/thumbnail-podcast-2.png'), thumbnailNum: "0", descriptionBefore: "Dr. Deepak Rao & Dr. Komal Rao on Indian Special Forces", descriptionAfter: "Dr. Deepak Rao & Dr. Komal Rao on Indian Special Forces" },
        { id: 3, type: 'local', videoUrl: 'https://streebal.com/videos/commando-stories-podcast-3.mp4', title: "Legendary Commando Trainer Major Deepak Rao with Dr. Komal", thumbnail: require('@/assets/thumbnail-podcast-3.png'), thumbnailNum: "0", descriptionBefore: "Legendary Commando Trainer Major Deepak Rao with Dr. Komal", descriptionAfter: "Legendary Commando Trainer Major Deepak Rao with Dr. Komal" }
        //{ id: 4, type: 'youtube', videoId: "4CyGAHQ8LbE", title: "Komal Rao & Major Dr. Deepak Rao Commando Stories - Part 1", thumbnail: require('@/assets/logo.png'), thumbnailNum: "0", descriptionBefore: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.", descriptionAfter: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat." },
      ],
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // Optional: for a smooth scrolling effect
      });
    },
    playVideo(video) {
      if (this.activeVideo?.id !== video.id) {
        this.activeVideo = null; // Optional: force re-render
        setTimeout(() => {
          this.activeVideo = video;
        }, 100);
      }
    },
  },
};
</script>

<style>
.card-margin {
  margin: 30px 0;
}

.paragraph {
  margin-bottom: 20px;
  line-height: 1.6;
}

/* Video container wrapper */
.video-container {
  position: relative;
  cursor: pointer;
  transition: box-shadow 0.3s ease;
}

.video-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Thumbnail image wrapper */
.video-thumbnail-wrapper {
  position: relative;
}

/* Thumbnail image */
.video-thumbnail {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
}

/* Overlay container for play button */
.play-button-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none; /* lets parent handle click */
}

/* Play button itself */
.play-button {
  width: 64px;
  height: 64px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  transition: background-color 0.3s ease;
}

/* Triangle inside the play button */
.play-button::after {
  content: '';
  display: inline-block;
  margin-left: 2px;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 20px solid white;
}

/* Title below thumbnail/video */
.video-title {
  font-size: 16px;
  text-align: center;
  color: var(--v-theme-on-surface, #333);
  margin-top: 8px;
}

/* Responsive iframe and local video styling */
.responsive-iframe,
.responsive-video {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

/* Responsive heights */
@media (max-width: 600px) {
  .video-container {
    height: 240px;
  }
}

@media (min-width: 601px) and (max-width: 1024px) {
  .video-container {
    height: 480px;
  }
}

@media (min-width: 1025px) {
  .video-container {
    height: 720px;
  }
}

</style>